import { ModalBody, ModalFooter } from "@chakra-ui/react";

import PrimaryButton from "components/PrimaryButton";
import { RequestModal, RequestModalProps } from "components/RequestModals";
import { IRM_CUSTOMER_SERVICE_PHONE_NUMBER } from "util/constants";

const FailureAcknowledge = ({
  isOpen,
  errorMsg,
  customerName,
  onClose = () => {
    return;
  },
}: RequestModalProps & { errorMsg: string; customerName: string }) => {
  return (
    <RequestModal isOpen={isOpen} canDismiss={false} header={customerName}>
      <ModalBody>
        {`${errorMsg}. Please contact IRM Customer Service at ${IRM_CUSTOMER_SERVICE_PHONE_NUMBER}.`}
      </ModalBody>
      <ModalFooter>
        <PrimaryButton mr={3} onClick={onClose}>
          Ok
        </PrimaryButton>
      </ModalFooter>
    </RequestModal>
  );
};

export default FailureAcknowledge;
